const MOJIBAKE_PATTERN = /Ã[\u0080-\u00BF]/;

export function decodeMultipartFilename(value?: string | null): string {
  if (!value) {
    return value ?? "";
  }

  if (!MOJIBAKE_PATTERN.test(value)) {
    return value;
  }

  const bytes = Uint8Array.from(value, (char) => char.charCodeAt(0));
  return new TextDecoder("utf-8").decode(bytes);
}
